module.exports = "/shifts/components/tips/copySchedules-49ea4d.html";